import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from '@app/services/authorization.service';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.css'],
  standalone: false
})
export class ForbiddenComponent {
  constructor(
    private router: Router,
    private authorizationService: AuthorizationService
  ) {}

  goToCustomers() {
    const route = this.authorizationService.getFirstAccessibleUserRoute();
    if (route && route !== '/forbidden') {
      this.router.navigate([route]);
    } else {
      this.router.navigate(['/login']);
    }
  }
}
